import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@/index.css'
import LoginIdScreen from '../screens/LoginIdScreen'
import { ensureUniversalLoginContext } from '../utils/helpers/universalLoginContext.ts'

async function bootstrap() {
  await ensureUniversalLoginContext('login-id')
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <LoginIdScreen />
    </StrictMode>,
  )
}

bootstrap()
